module.exports = __webpack_public_path__ + "static/media/LOGO.f635e010.png";